var buttonTrigger = $(".button-trigger");
if (buttonTrigger.get(0)) {
    buttonTrigger.on("click", function (event) {
        if (event) {
            event.preventDefault();
        }
        var self = $(this);
        var buttonName = self.attr("name");
        var hiddenName = buttonName.substr(0, buttonName.indexOf('-'));
        var form = self.parents(".EPiServerForms");
        //check if is multistep form
        if (form.find(".FormStep").get(0)) {
            var step = self.parents(".FormStep");
            step.find(".FormChoice__Input--Radio[value='not selected']").trigger("click");
            step.find(".FormChoice__Input--Radio[name='" + hiddenName + "'][value='selected']").trigger("click");

            form.find(".Form__NextPreviousUi .btnNext").trigger("click");

        } else {
            form.find(".FormChoice__Input--Radio[value='not selected']").trigger("click");
            form.find(".FormChoice__Input--Radio[name='" + hiddenName + "'][value='selected']").trigger("click");

            form.find(".Form__NextPreviousUi .btnNext").trigger("click");
        }
        return false;
    });
}